import type { JSX, ReactNode } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Loader from "./Loader";

type ButtonProps = {
  text?: ReactNode;
  gradient?: string;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
};

const Button = ({
  text = "Enter Text",
  gradient = "linear-gradient(135deg, #004e92, #00c6ff)",
  onClick,
  disabled = false,
  loading = false,
  fullWidth = false,
}: ButtonProps): JSX.Element => {
  return (
    <button
      className="custom-gradient-btn btn text-white px-4 py-1 border-0"
      onClick={onClick}
      disabled={disabled}
      style={{
        backgroundImage: gradient,
        borderRadius: "2rem",
        fontSize: "1.25rem",
        fontFamily: '"JetBrains Mono", monospace',
        transition: "all 0.3s ease-in-out",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: fullWidth ? "100%" : undefined,
        display: "inline-flex",
        justifyContent: "center",
      }}
    >
      {loading && (
        <span
          className="me-2"
          style={{ display: "inline-flex", alignItems: "center" }}
        >
          <Loader size="sm" />
        </span>
      )}

      <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
        {text}
      </span>

      <style>
        {`
          .custom-gradient-btn:hover:enabled {
            transform: scale(1.05);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
            filter: brightness(1.1);
          }
          @media (max-width: 576px) {
            .custom-gradient-btn { font-size: 1rem !important; padding: 0.35rem 1rem !important; }
          }
        `}
      </style>

      <style>
        {`
          .custom-gradient-btn:hover:enabled {
            transform: scale(1.05);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
            filter: brightness(1.1);
          }
        `}
      </style>
    </button>
  );
};

export default Button;
